
import Api2Talk from "../api2talk";

export const DeleteOption = async (id) => { 
  let data = [];
  await Api2Talk.delete(`channelregistrationnumberrequest/${id}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getChannelsAssociations = async (registrationNumberRequestId) => { 
  let data = [];
  await Api2Talk.get(`channelregistrationnumberrequest/getbyregistrationnumberrequestid/${registrationNumberRequestId}`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const saveChannelAssociation = async (registrationNumberRequestId, channelId, confirmDefaultChange = false) => {
  let data = [];
  const formData = new FormData();
  formData.append('RegistrationNumberRequestId', registrationNumberRequestId);
  formData.append('ChannelsSelected[0].Id', channelId);
  formData.append('ChannelsSelected[0].IsDefault', true);

  if (confirmDefaultChange) {
    formData.append('ConfirmDefaultChange', true);
  }

  await Api2Talk.post('channelregistrationnumberrequest', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
      .then(result => {
          data = result.data;
       })
       .catch(err => {
          data = err.response?.data || err;
  });
  return data;
};
